"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 在移动端浏览器或微信等第三方App Webview中
 * 调起美团/点评客户端app webview，打开h5链接
 *
 * ### Example
 * ```
 * const appName = 'group';
 * const appUrl = 'http://a.com';
 * const webUrl = 'http://b.com';
 * callUpApp(appName, appUrl, webUrl);
 * ```
 * 美团：meituan
 * 大众点评：dianping
 * 猫眼电影：maoyan
 * 美团外卖：waimai
 * 榛果民宿：zhenguo
 * 开店宝：kaidianbao
 * 格瓦拉：gewara
 *
 */
var object_to_query_1 = require("./object-to-query");
var supportAppName = ['group', 'dianping-nova', 'meituan', 'dianping', 'waimai', 'maoyan', 'zhenguo', 'kaidianbao', 'gewara', 'conch'];
function callUpApp(appName, appUrl, webUrl) {
    var appNameMap = {
        'meituan': 'meituan',
        'group': 'meituan',
        'dianping-nova': 'dianping',
        'dianping': 'dianping'
    };
    var calcAppName = supportAppName.indexOf(appName) > -1 ? appName : 'group';
    var realAppName = appNameMap[calcAppName] || calcAppName;
    var transferUrl = "https://m.dianping.com/cube/evoke/" + realAppName + ".html";
    var params = {
        url: appUrl,
        web: webUrl
    };
    location.href = transferUrl + '?' + object_to_query_1.objectToQuery(params);
}
exports.callUpApp = callUpApp;
